import React from "react"
import { reduxForm } from "redux-form"
import { Button, TYPES } from "components/Button"
import SelectField from "../SelectField"
import FieldWrapper from "components/FieldWrapper"
import styles from "./styles.scss"
import FileUploadField from "components/Fields/FileUploadField"

class CompanyForm extends React.Component {
  render() {
    const {
      company,
      counties,
      categories,
      submitText,
      handleSubmit,
    } = this.props
    return (
      <form className={styles.container} onSubmit={handleSubmit}>
        <FieldWrapper
          label="Företagsnamn"
          placeholder="Exempel: Företag AB"
          name="companyName"
          component="input"
          type="text"
        />

        <FieldWrapper
          label="Telefonnummer"
          placeholder="Exempel: 070-0000000"
          name="phone"
          component="input"
          type="text"
        />

        <FieldWrapper
          label="Epost"
          placeholder="Exempel: exempel@mail.se"
          name="email"
          component="input"
          type="email"
        />

        <FieldWrapper
          label="Kategori"
          placeholder="Välj en eller flera kategorier"
          name="companyCategories"
          options={categories}
          component={SelectField}
        />

        <FieldWrapper
          label="Kommun"
          name="companyCounties"
          placeholder="Välj en eller flera kommuner"
          options={counties}
          component={SelectField}
        />

        <FieldWrapper
          label="Logo"
          name="companyLogo"
          component={FileUploadField}
          className={styles.fileUploadWrapper}
        />
        
        <div
          className={company&& company.logoUrl? styles.companyLogo : styles.noCompanyLogo}
          style={{
            backgroundImage: company&& `url(${company.logoUrl})`
          }}
        />

        <Button buttonType={TYPES.SUCCESS}>{submitText}</Button>
      </form>
    )
  }
}

CompanyForm = reduxForm({
  form: "companyForm",
})(CompanyForm)

export default CompanyForm



// WEBPACK FOOTER //
// src/components/CompanyForm/index.jsx